import { useService } from 'react-reservice';

import themeService from './service';

export const useTheme = () => {
  return useService(themeService, (state) => state);
};

export { themeService };
